import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "home py-56"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "professionals-actions" }
const _hoisted_5 = { class: "h4 title text-primary mb-32" }
const _hoisted_6 = { class: "fw-normal" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-user-add-alt me-12",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-user me-12",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-user me-12",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-clinic me-12",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-send-hor me-12",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.authUser)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('Hola,')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.user.name), 1)
              ]),
              (_ctx.can('admin.professional.store'))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {name: 'admin.professional.store'},
                    class: "btn btn-primary btn-icon btn-md w-100 mb-8",
                    "aria-label": _ctx.$t('Crear profesional')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Añadir nuevo profesional')), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "aria-label"]))
                : _createCommentVNode("", true),
              (_ctx.can('admin.professional.index'))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: {name: 'admin.professional.index'},
                    class: "btn btn-primary btn-icon btn-md w-100 mb-8",
                    "aria-label": _ctx.$t('Ver profesionales')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Ver profesionales')), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "aria-label"]))
                : _createCommentVNode("", true),
              (_ctx.can('admin.patient.index'))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: {name: 'admin.patient.index'},
                    class: "btn btn-primary btn-icon btn-md w-100 mb-8",
                    "aria-label": _ctx.$t('Ver pacientes')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Ver pacientes')), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "aria-label"]))
                : _createCommentVNode("", true),
              (_ctx.can('admin.clinic.index'))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 3,
                    to: {name: 'admin.clinic.index'},
                    class: "btn btn-primary btn-icon btn-md w-100 mb-8",
                    "aria-label": _ctx.$t('Ver clínicas')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Ver clínicas')), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "aria-label"]))
                : _createCommentVNode("", true),
              (_ctx.can('admin.purchase-authorization.index'))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 4,
                    to: {name: 'admin.purchase-authorization.index'},
                    class: "btn btn-primary btn-icon btn-md w-100 mb-8",
                    "aria-label": _ctx.$t('Ver aut. de compra')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Ver aut. de compra')), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "aria-label"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}